/**
 * VIB-1204: differanseberegning for budsjettpanelet i bilagsgodkjenningen
 * (`VoucherBudgetPanel`). Ren funksjon, ingen React/Supabase-avhengighet —
 * skilt ut for Vitest-testbarhet (jf. `.claude/skills/endringssjekk`
 * test-required-gaten for `src/lib/**`).
 *
 * Formel: budsjettbeløp − allerede ført bilagskost (godkjente allokeringer,
 * `groupAllocationsByBudgetLine`) − dette bilagets beløp. Positivt/null =
 * innenfor budsjett (grønn), negativt = overtrukket (rød).
 *
 * Skal semantisk matche budsjett-tabbens «x bilag · y kr»-indikator
 * (`BudgetTabContent.tsx`) — IKKE en ny KPI/formel, kun en visningsberegning
 * for ett ekstra ledd (dette bilaget) lagt til det samme grunnlaget.
 */
export function calcBudgetLineDiff(
  budgetLineAmount: number | null | undefined,
  alreadyAllocatedAmount: number,
  thisVoucherAmount: number | null | undefined,
): number {
  return (budgetLineAmount ?? 0) - alreadyAllocatedAmount - (thisVoucherAmount ?? 0);
}
